import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';
import { TiposPublicoPrioritarioService } from 'src/app/services/tipos-publico-prioritario/tipos-publico-prioritario.service';
import { TiposPublicoPrioritario } from 'src/app/core/tipos-publico-prioritario';

@Component({
  selector: 'combo-tipo-publico-prioritario',
  templateUrl: './combo-tipo-publico-prioritario.component.html',
  styleUrls: ['./combo-tipo-publico-prioritario.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ComboTipoPublicoPrioritarioComponent implements OnInit {

  @ViewChild('comboTipoPublicoPrioritario', {static: false}) comboTipoPublicoPrioritario;

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;

  @Output() valorChange = new EventEmitter();

  dados = [];
  data: any = {};

  constructor(private tiposPublicoPrioritarioService: TiposPublicoPrioritarioService) {
  }

  ngOnInit(): void {
    this.data = Date.now();

    // Carrega tipos público prioritário dinamicamente do serviço
    this.tiposPublicoPrioritarioService.getAll().subscribe((tipos: TiposPublicoPrioritario[]) => {
      this.dados = tipos;
      this.preencherCombo();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.preencherCombo();
  }

  private preencherCombo(){
    if (this.selecionado && this.dados.length) {
      if (typeof this.selecionado === 'number' || typeof this.selecionado === 'string') {
        this.selecionado = _.find(this.dados, { id: this.selecionado});
      }
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }

}
